import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '../../utils/cn';

export const tooltipContentVariants = cva('rocco-tooltip-content', {
    variants: {
        variant: {
            default:
                'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-tooltip overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md',
        },
        color: {
            default: 'bg-popover text-popover-foreground',
            dark: 'bg-gray-800 text-white',
        },
    },
    defaultVariants: {
        variant: 'default',
        color: 'default',
    },
});

export const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> &
        VariantProps<typeof tooltipContentVariants>
>(({ className, sideOffset = 4, variant, color, ...props }, ref) => (
    <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={cn(
                tooltipContentVariants({ variant, className, color }),
            )}
            {...props}
        />
    </TooltipPrimitive.Portal>
));

TooltipContent.displayName = TooltipPrimitive.Content.displayName;
